import { fetchFullNurse } from "@api/nurses";
import { useNurseStore } from "@store/nurseStore";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useEffect } from "react";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";

/**
 * 간호사 목록을 가져와 Zustand 스토어를 업데이트하는 TanStack Query 훅
 * @param isAdmin 관리자 여부
 * @param groupId (관리자용) 조회할 그룹 ID
 * @returns TanStack Query의 `useQuery` 결과 객체
 */

// 일반 사용자: 자동으로 자신의 간호사 목록 조회
// 관리자: groupId가 있을 때만 해당 그룹의 간호사 목록 조회
export const useFullNurseListQuery = ({
  isAdmin,
  groupId,
}: {
  isAdmin: boolean;
  groupId?: string;
}) => {
  const setNurseList = useNurseStore((state) => state.setNurseList);

  const isQueryEnabled = isAdmin ? !!groupId : true;
  const queryId = isAdmin ? groupId : undefined;

  const queryResult = useQuery({
    queryKey: QUERY_KEYS.nurses.fullSchema(queryId),
    queryFn: () => fetchFullNurse(queryId),
    enabled: isQueryEnabled,
  });

  const { data, isSuccess, error, isError } = queryResult;

  useEffect(() => {
    if (isSuccess) {
      setNurseList(data);
    }
  }, [isSuccess, data, setNurseList]);

  useEffect(() => {
    if (isError) {
      console.error("간호사 정보를 불러오는데 실패했습니다.", error);
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        window.location.href = "/login";
      }
    }
  }, [isError, error]);

  return queryResult;
};
